module.exports = __webpack_public_path__ + "static/media/immeuble-fond-back-Tour-Eiffel.a27ecdc8.png";